import type { Dict } from "./pl.js";

export const ja: Dict = {
  navCats: "サービス分野",
  navHow: "ご利用の流れ",
  navOps: "事業者の方へ",
  navPrice: "料金",
  navContact: "お問い合わせ",
  navBook: "事業者パネルのデモ",
  pill: "サービス事業者のための予約プラットフォーム",
  title1: "あなたのサービスが、",
  title2: "ひとりでに予約される。",
  sub: "b00k は客室・車両・診療などすべてのカレンダーを、ひとつの予約システムにまとめます。お客様はウェブとチャットから自分で予約し、システムが時間枠を見張って重複を防ぎます。",
  ctaBook: "事業者アカウントを作成",
  ctaOperator: "お客様向け画面を見る",
  heroMeta: "YOUR-COMPANY.B00K.ONLINE · 事業者ごとに専用サブドメイン",
  cardChip: "確定",
  cardNote: "予約はウェブとチャットから自動で入り、その場でスケジュールを押さえます。",
  catsKick: "サービス分野",
  catsTitle: "b00k で扱えるもの",
  catsSub: "すべてのサービスをひとつの基盤で。時間制のサービスは連続して並び、客室と車両は日単位で並行して予約されます。",
  cat1t: "客室",
  cat1d: "1 泊から連泊まで対応する客室とアパートメント。同じ日程で複数の部屋を並行して予約できます。",
  cat2t: "車両",
  cat2d: "日単位のコンパクトカーと SUV。空き状況カレンダーが貸出と返却を見張ります。",
  cat3t: "レジャー",
  cat3d: "サウナ、スパ、カヤック。所要時間を定めたうえで、時刻を指定して予約します。",
  cat4t: "ヘアサロン",
  cat4d: "カットとカラー。時刻を選ぶだけで、施術にかかる時間ぴったりを押さえます。",
  cat5t: "エステ",
  cat5d: "ネイルとマッサージ。他のサービスと組み合わせれば、所要時間はひとつの枠にまとまります。",
  cat6t: "医療",
  cat6d: "時刻を決めた診察と検査。診療カレンダーはひとりでに整います。",
  cat7t: "修理",
  cat7d: "自動車、自転車、ノートパソコン — いずれにも対応します。",
  cat8t: "個人指導",
  cat8d: "語学レッスンもピアノのお稽古も、当プラットフォームで運営できます。",
  cat9t: "その他",
  cat9d: "あなたの業界の事情 + 私たちの経験 = 成果。",
  howKick: "ご利用の流れ",
  howTitle: "3 ステップ、電話は不要",
  s1t: "サービスと設備を登録",
  s1d: "客室・車両・予約枠を、所要時間と料金とともに登録します。登録時にすべてのアカウントを検証します — あなたのものも、お客様のものも。",
  s2t: "お客様が自分で予約",
  s2d: "ウェブまたはチャット（WhatsApp・Messenger）から。所要時間は加算され、客室は並行して押さえられ、本当に空いている枠だけが表示されます。",
  s3t: "システムがスケジュールを見張る",
  s3d: "確定した時点で枠は押さえられ、同じサービスの同じ時刻を 2 人が予約することはありません。キャンセルと変更にも対応します。",
  newChip: "新機能",
  chatLine: "お客様はチャットのまま予約できます — WhatsApp または Messenger で。",
  opsKick: "事業者の方へ",
  opsTitle: "スケジュールがあなたのために働く",
  opsSub: "客室・車両・予約をひとつのカレンダーに。重複は自動で阻止され、チャット経由の予約は自動で入り、稼働率と売上をその場で確認できます。",
  opsCta: "事業者パネルを見る",
  f1: "当日のカレンダーと設備の稼働状況をひと画面で",
  f2: "予約の重複を自動でブロック",
  f3: "ウェブとチャットからの予約 — WhatsApp / Messenger",
  f4: "顧客、予約メモ、主要指標",
  priceKick: "料金",
  priceTitle: "予約と同じくらい、わかりやすく",
  month: "月",
  recommended: "おすすめ",
  soon: "近日公開",
  custom: "個別見積",
  opsSuffix: "名のスタッフ",
  priceNote: "月額は、パネルにアクセスできるスタッフの人数によって決まります。",
  t1f1: "カレンダーとウェブ予約",
  t1f2: "WhatsApp / Messenger チャット",
  t1f3: "顧客、メモ、リマインダー",
  t2f1: "SOLO のすべて",
  t2f2: "設備とサービスは無制限",
  t2f3: "レポートと稼働率の指標",
  t3f1: "TEAM のすべて",
  t3f2: "スタッフのシフトと権限",
  t3f3: "API と外部連携",
  t4f1: "GROUP のすべて",
  t4f2: "導入支援と SLA",
  t4f3: "個別の契約と請求",
  conKick: "お問い合わせ・アクセス",
  conTitle: "あなたの所在地、お客様の道順",
  dirKick: "アクセス — お客様に表示される内容",
  dir1: "お車で：イェレニャ・グラから国道 3 号線、シュクラルスカ・ポレンバ中心部の出口を降り、ズドロヨヴァ通りを 5 分。",
  dir2: "鉄道で：シュクラルスカ・ポレンバ・グルナ駅から、中心部方面へ徒歩 12 分。",
  dir3: "敷地内に来客用駐車場 — 無料・予約不要。",
  footUser: "お客様向け画面",
  footOp: "事業者パネル",

  wizTitle: "事業者アカウントを作成",
  wizSub: "7 ステップ。完了すると専用サブドメインとすぐ使えるパネルが手に入ります。",
  wizStep1: "会社",
  wizStep2: "サブドメイン",
  wizStep3: "業種",
  wizStep4: "プラン",
  wizStep5: "管理者",
  wizStep6: "決済",
  wizStep7: "確認",
  wizNext: "次へ",
  wizBack: "戻る",
  wizFinish: "アカウントを作成",
  fCompany: "会社名",
  fNip: "納税者番号（NIP）",
  fPhone: "電話番号",
  fAddress: "住所",
  fSlug: "サブドメイン",
  slugHint: "お客様がこの住所であなたのサービスを予約します。",
  slugChecking: "空き状況を確認しています…",
  slugFree: "このサブドメインは使えます。",
  slugTaken: "このサブドメインは既に使用されています。",
  slugInvalid: "サブドメイン：3〜63 文字、小文字・数字・ハイフン（先頭と末尾は不可）。",
  industriesHint: "取り扱う業種を選んでください。あとからパネルで追加できます。",
  planHint: "プランはいつでも変更できます — データは失われません。",
  fName: "氏名",
  fEmail: "メールアドレス",
  fPass: "パスワード（8 文字以上）",
  fPass2: "パスワードの再入力",
  fTerms: "b00k.online の利用規約に同意し、予約対応のためのデータ処理に同意します。",
  payTitle: "お客様の決済",
  payHint: "任意です。予約確定時にオンライン決済を受け付けられます。",
  payEnable: "オンライン決済を受け付ける",
  payMethods: "決済手段",
  sumTitle: "確認",
  sumCompany: "会社",
  sumSub: "サブドメイン",
  sumIndustries: "業種",
  sumPlan: "プラン",
  sumAdmin: "管理者",
  sumPayments: "決済",
  yes: "はい",
  no: "いいえ",
  doneTitle: "事業者アカウントの準備が整いました",
  doneSub: "サブドメインは稼働中です。パネルにログインしてサービスを追加すれば、予約はすぐに始まります。",
  doneOpen: "事業者パネルを開く",
  doneBooking: "予約ページを見る",
  companyProofOk: "会社の管理者としてログインしました：",
  companyLoginOther: "別のアカウントでログイン",
  errGeneric: "アカウントを作成できませんでした。入力内容を確認して、もう一度お試しください。",
};
